export default {
  isAuthorized: false,
  user: {},
}
